import React from 'react';
import { cn } from './lib/utils';

interface SeparatorProps {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
}

const Separator: React.FC<SeparatorProps> = ({
  className,
  orientation = 'horizontal',
}) => {
  return (
    <div
      className={cn(
        'bg-border h-full my-2',
        orientation === 'horizontal' ? 'h-[1px] w-full' : 'w-[1px]',
        className
      )}
      role="separator"
    />
  );
};

export { Separator };
